import { createAction, props } from '@ngrx/store';
import { AuthData } from 'src/app/utility/model/token-auth';

export const setAuthData = createAction(
  'Set Auth Data',
  props<Partial<AuthData>>()
);
